export const LIST_TITLE_REQUEST = 'LIST_TITLE_REQUEST'
export const LIST_TITLE_SUCCESS = 'LIST_TITLE_SUCCESS'
export const LIST_TITLE_FAIL = 'LIST_TITLE_FAIL'

export const LIST_TITLE_SUMMARY_REQUEST = 'LIST_TITLE_SUMMARY_REQUEST'
export const LIST_TITLE_SUMMARY_SUCCESS = 'LIST_TITLE_SUMMARY_SUCCESS'
export const LIST_TITLE_SUMMARY_FAIL = 'LIST_TITLE_SUMMARY_FAIL'

export const CREATE_TITLE_REQUEST = 'CREATE_TITLE_REQUEST'
export const CREATE_TITLE_SUCCESS = 'CREATE_TITLE_SUCCESS'
export const CREATE_TITLE_FAIL = 'CREATE_TITLE_FAIL'

export const DETAIL_TITLE_REQUEST = 'DETAIL_TITLE_REQUEST'
export const DETAIL_TITLE_SUCCESS = 'DETAIL_TITLE_SUCCESS'
export const DETAIL_TITLE_FAIL = 'DETAIL_TITLE_FAIL'

export const UPDATE_TITLE_REQUEST = 'UPDATE_TITLE_REQUEST'
export const UPDATE_TITLE_SUCCESS = 'UPDATE_TITLE_SUCCESS'
export const UPDATE_TITLE_FAIL = 'UPDATE_TITLE_FAIL'

export const DELETE_TITLE_REQUEST = 'DELETE_TITLE_REQUEST'
export const DELETE_TITLE_SUCCESS = 'DELETE_TITLE_SUCCESS'
export const DELETE_TITLE_FAIL = 'DELETE_TITLE_FAIL'
